import Typography from "ds/components/Typography";

const Documentation = () => (
  <>
    <Typography tag="p" variant="p-t7" margin="0 0 small 0">
      Sharing between accounts
    </Typography>
    <Typography tag="p" variant="p-body2">
      Unlike Stacks, modules can be shared between Spacelift accounts in a sense that while they're
      always managed by a single account, they can be made accessible to an arbitrary number of
      other accounts. In order to share the module with other accounts, please add their names in
      subdomain form (all lowercase)
    </Typography>

    <Typography tag="p" variant="p-t7" margin="x-large 0 small 0">
      Sharing between spaces
    </Typography>
    <Typography tag="p" variant="p-body2">
      Modules can also be shared between different spaces within the same account. This allows for
      greater flexibility and collaboration across teams. To share a module with another space,
      simply add the space name in the appropriate field.
    </Typography>
  </>
);

export default Documentation;
